import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaBars, FaTimes } from 'react-icons/fa';

interface HeaderProps {
  activeSection?: string;
  setActiveSection?: (section: string) => void;
  scrollToSection?: (sectionId: string) => void;
  selectedTheme?: string;
  navItems?: { id: string; labelKey?: string; label?: string }[];
}

const defaultScrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    window.scrollTo({
      top: element.offsetTop - 80,
      behavior: 'smooth'
    });
  }
};

const defaultNavItems = [
  { id: 'home', labelKey: 'nav.home' },
  { id: 'project', labelKey: 'nav.project' },
  { id: 'features', labelKey: 'nav.features' },
  { id: 'roadmap', labelKey: 'nav.roadmap' },
  { id: 'investment', labelKey: 'nav.investment' },
  { id: 'contact', labelKey: 'nav.contact' }
];

const Header: React.FC<HeaderProps> = ({
  activeSection = '',
  setActiveSection = () => {},
  scrollToSection = defaultScrollToSection,
  navItems = defaultNavItems
}) => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [activeSection]);

  return (
    <nav className="main-nav">
      <div className="nav-container">
        <div className="logo">
          <a href="https://partner.quevvy.com" className="logo-link">
            <span className="logo-icon">
              <img src="quevvy_logo_transparent.png" alt="" width="40px" />
            </span>
            <span className="logo-text">
              <img src="/img/quevvy_logo_transparent.png" height="25px" width="100px" alt="Quevvy" />
              <small>{t('nav.partnerSearch')}</small>
            </span>
          </a>
        </div>

        <button
          className="nav-toggle"
          type="button"
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((prev) => !prev)}
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <ul className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
          {navItems.map((item) => (
            <li key={item.id}>
              <button
                className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
                onClick={() => {
                  setIsMenuOpen(false);
                  setActiveSection(item.id);
                  scrollToSection(item.id);
                }}
              >
                {item.labelKey ? t(item.labelKey) : item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Header;
